export const SkillsTableColumns = (isArabic) => [
    { id: 'name', label: isArabic ? 'الاسم' : 'Name', align: 'start' },
    { id: 'is_active', label: isArabic ? 'الحالة' : 'Status', align: 'center' },
    { id: 'created_at', label: isArabic ? 'تاريخ الإضافة' : 'Created At', align: 'start' }
];